import React from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'antd';

import PlanLimitAlert from '../common/PlanLimitAlert';
import { apiErrorMessage } from '../../utils/apiErrors';
import { FailureList, RunProgress } from './CheckStep';
import { countWords, resultSummary } from './importCopy';

/**
 * Step 4: the rows going in, then what became of them. What landed stands
 * whatever happens next, and the person is told what did not, and that an
 * import can be taken back, and by whom: undoing one is a manager's act
 * (keepr-api docs/SCHEMA.md § Imports), and importing is not.
 */
export default function ImportResultStep({ commit, cardName, lines, leftAtCheck = 0, imports, canUndo }) {
	if (commit.phase !== 'done') {
		return (
			<section className="spreadsheet-import__panel" aria-label="Import">
				<RunProgress done={commit.done} total={commit.total} verb="Importing" />
			</section>
		);
	}
	const { landed, failed, unsent, planRefusal, stopped, error } = commit.result;
	return (
		<section className="spreadsheet-import__panel" aria-label="Import">
			<p className="spreadsheet-import__summary" aria-live="polite">
				{resultSummary({ landed, left: leftAtCheck + failed.length + unsent.length, cardName })}
			</p>
			{planRefusal ? <PlanLimitAlert refusal={planRefusal} /> : null}
			{error ? (
				<Alert
					type="warning"
					showIcon
					message={apiErrorMessage(error, 'keepr stopped answering.')}
					description={`${landed ? `${countWords(landed, 'row')} landed. ` : ''}Send the rest when you are ready: a row that landed is not added twice.`}
				/>
			) : null}
			{stopped && unsent.length ? <p className="spreadsheet-import__note">{`Stopped. ${countWords(unsent, 'row')} still to send.`}</p> : null}
			<FailureList lines={lines} />
			{landed ? (
				<p className="spreadsheet-import__note">
					{canUndo
						? <>Wrong file? <Link to={imports}>Settings → Imports</Link> undoes the whole import.</>
						: 'A manager of this collection can undo this import from Settings → Imports.'}
				</p>
			) : null}
		</section>
	);
}
